import { HttpClient, HttpErrorResponse, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, retry, throwError } from 'rxjs';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { ResponseService, RespuestasDTO } from 'src/app/types/type';
import { environment } from 'src/environments/environment';
enum methods {
  UpdateRelPreguntaRespuestas = 'UpdateRelPreguntaRespuestas',
}

@Injectable({
  providedIn: 'root'
})
export class PasoCincoService {
  headers: HttpHeaders;
  URL: string

  constructor(private http: HttpClient) {
    this.URL = environment.urlService
    this.headers = new HttpHeaders();
    if (localStorage?.jwt) {
      this.headers = new HttpHeaders({
        'Authorization': localStorage.jwt
      })
    }
  }

  updateRelPreguntaRespuestas(respuestas: RespuestasDTO) {
    return this.http.post<ResponseService>(`${this.URL}${methods.UpdateRelPreguntaRespuestas}`, respuestas, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  private handleError(error: HttpErrorResponse) {
    console.log('Error en Usuarios Service' + error.message);
    Utilerias.alertClient('Error al hacer la petición', 'Intente de nuevo', 1);
    if (error.status === HttpStatusCode.Unauthorized) {
      Utilerias.closeSesion(this.http);
      return throwError(() => new Error('!Error Unauthorized, verifique sus credenciales!'))
    }
    return throwError(() => new Error('!Fuera de servicio, intente nuevamente!'))
  }
}
